import { isString } from '@/utils';

export function formatCash(n: any, fixed = 2) {
  if (!n) {
    return null;
  }
  if (isString(n)) {
    n = parseFloat(n);
  }
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(fixed) + 'K';
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(fixed) + 'M';
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(fixed) + 'B';
  if (n >= 1e12) return +(n / 1e12).toFixed(fixed) + 'T';
}
